import { kulaNexusHttp } from '@/lib/kula-nexus-http';
import { http } from '@/lib/http';

const getAISearchResults = async (_payload: any, signal?: AbortSignal) => {
  const response = await kulaNexusHttp.post('/search', _payload, { signal });
  return response.data;
};

const getAISummaries = async (_payload: any) => {
  const response = await kulaNexusHttp.post('/search', _payload);
  return response.data;
};

const getFlows = async (params: { q: string }) => {
  const response = await http.get('/search/outreaches', { params });
  return response.data;
};

export const API_SERVICE = {
  getAISearchResults,
  getAISummaries,
  getFlows,
};
